import React from "react";
import PropTypes from "prop-types";
import { StyledTag } from "./StyledTag";
import parse, { domToReact } from "html-react-parser";
import "./style.scss";

const HTML_TAG = "tag";
const HIGHLIGHT_TAG = "highlight";
const HEADING_TAG = "h3";
const HYPERLINK_TAG = "hyperlink";
/**
 * PlainText:
 *  - Component renders any passed HTML String to DOM
 *  - Also replace custom <highlight> tag to <b> with data-id attribute for
 *    invoking glossary
 */
export function PlainText(props) {
  const options = {
    replace: (node) => {
      if (node.type === HTML_TAG) {
        let tagProps = { ...node.attribs };
        if (node.name === HIGHLIGHT_TAG) {
          const onClick = (contentId) => (event) =>
            props.onClickHighlight(contentId, event);

          tagProps = {
            ...tagProps,
            onClick: onClick(node.attribs.contentid),
            tabIndex: "0",
            role: "button",
          };
          return (
            <StyledTag tag="b" className="highlight" tagProps={tagProps}>
              {domToReact(node.children, options)}
            </StyledTag>
          );
        } else if (node.name === HEADING_TAG) {
          return (
            <StyledTag tag={node.name} className="heading" tagProps={tagProps}>
              {domToReact(node.children, options)}
            </StyledTag>
          );
        } else if (node.name === HYPERLINK_TAG) {
          return (
            <sup
              onClick={() => {
                const elem = document.getElementById(tagProps.hypref);
                elem.style.backgroundColor = "#66cef5";
                elem.style.transition = "2s";
                elem.scrollIntoView({ behavior: "smooth" });
                setTimeout(() => {
                  elem.style.backgroundColor = "transparent";
                }, "2000");
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  const elem = document.getElementById(tagProps.hypref);
                  elem.style.backgroundColor = "#66cef5";
                  elem.style.transition = "2s";
                  elem.scrollIntoView({ behavior: "smooth" });
                  setTimeout(() => {
                    elem.style.backgroundColor = "transparent";
                  }, "2000");
                }
              }}
              tabIndex="0"
              role="button"
              aria-label={`Go to footnote: ${domToReact(node.children, options)}`}
            >
              <StyledTag
                tag={node.name}
                className="hyperlink-ref"
                tagProps={tagProps}
              >
                {domToReact(node.children, options)}
              </StyledTag>
            </sup>
          );
        } else {
          if (node.parent) {
            return (
              <StyledTag tag={node.name} tagProps={tagProps}>
                {domToReact(node.children, options)}
              </StyledTag>
            );
          } else {
            return (
              <StyledTag
                tag={node.name}
                tagProps={tagProps}
                isParent
                className={props.className}
              >
                {domToReact(node.children, options)}
              </StyledTag>
            );
          }
        }
      }
    },
  };

  return parse(props.text, options);
}

PlainText.propTypes = {
  /**
   * HTML content to be rendered to DOM passed in as string
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName to se on HTML Tag
   */
  className: PropTypes.string,
  /**
   * Callback to invoke for when Highlighted tag is clicked
   */
  onClickHighlight: PropTypes.func,
};

PlainText.defaultProps = {
  text: "",
  className: "",
};
